import { render, staticRenderFns } from "./ModalAddEMR.vue?vue&type=template&id=8d2bd76a&scoped=true"
import script from "./ModalAddEMR.vue?vue&type=script&lang=js"
export * from "./ModalAddEMR.vue?vue&type=script&lang=js"
import style0 from "./ModalAddEMR.vue?vue&type=style&index=0&id=8d2bd76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2bd76a",
  null
  
)

export default component.exports